import { render } from "./GesUserPage.vue?vue&type=template&id=0a603852"
import script from "./GesUserPage.vue?vue&type=script&lang=js"
export * from "./GesUserPage.vue?vue&type=script&lang=js"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__